module.exports = __webpack_public_path__ + "img/oelsnitz-ticket-phone-combo-shadow.8397fd2d.png";